import styled from "styled-components/macro";

export default styled.ul`
  .list:not(:first-child) {
    margin-left: 20px;
  }

  span {
    font-size: 20px;
  }

  .content {
    margin-left: 20px;
  }
`;
